import SalesReport from './SalesReport';
import BuyerSummaryReport from './BuyerSummaryReport';
import InventoryReport from './InventoryReport';
import TitleStatusReport from './TitleStatusReport';
import TitlesReceivedReport from './TitlesReceivedReport';
import MissingTitlesBySellerReport from './MissingTitlesBySellerReport';
import InvoicingReport from './InvoicingReport';
import IfSalesReport from './IfSalesReport';
import UnsoldAssetsReport from './UnsoldAssetsReport';
import SalesAndExpenseReport from './SalesAndExpenseReport';
import SellerDetailReport from './SellerDetailReport';
import AssetsSoldBySellerReport from './AssetsSoldBySellerReport';
import SoldByPaddleServiceReport from './SoldByPaddleServiceReport';
import AssetsByLocationReport from './AssetsByLocationReport';
import BlockReport from './BlockReport';
import SoldAssetsStatusReport from './SoldAssetsStatusReport';
import AssetsSoldSummary from './AssetsSoldSummary';
import SellerConfirmationReport from './SellerConfirmationReport';
import WebsiteBuyersReport from './WebsiteBuyersReport';
import FeesNotApprovedReport from './FeesNotApprovedReport';
import JournalEntryReport from './JournalEntryReport';
import ReversedEntryReport from './ReversedEntryReport';
import TitlesToWorkReport from './TitlesToWorkReport';

export const REPORT_REGISTRY = [
  { value: 'sales-report', label: 'Sales Report', Component: SalesReport },
  { value: 'buyer-summary-report', label: 'Buyer Summary Report', Component: BuyerSummaryReport },
  { value: 'inventory-report', label: 'Inventory Report', Component: InventoryReport },
  { value: 'title-status-report', label: 'Title Status Report', Component: TitleStatusReport },
  { value: 'titles-received-report', label: 'Titles Received - Sold Assets Only', Component: TitlesReceivedReport },
  { value: 'missing-titles-by-seller-report', label: 'Missing Titles By Seller Report', Component: MissingTitlesBySellerReport },
  { value: 'invoicing-report', label: 'Invoicing Report', Component: InvoicingReport },
  { value: 'if-sales-report', label: 'If Sales Report', Component: IfSalesReport },
  { value: 'unsold-assets-report', label: 'Unsold Assets Report', Component: UnsoldAssetsReport },
  { value: 'sales-and-expense-report', label: 'Sales and Expense Report', Component: SalesAndExpenseReport },
  { value: 'seller-detail-report', label: 'Seller Detail Report', Component: SellerDetailReport },
  { value: 'assets-sold-by-seller-report', label: 'Assets Sold By Seller Report', Component: AssetsSoldBySellerReport },
  { value: 'sold-by-paddle-service-report', label: 'Sold To Buyers Per Paddle Service', Component: SoldByPaddleServiceReport },
  { value: 'assets-by-location-report', label: 'Assets By Location Report', Component: AssetsByLocationReport },
  { value: 'block-report', label: 'Block Report', Component: BlockReport },
  { value: 'sold-assets-status-report', label: 'Sold Assets Status Report', Component: SoldAssetsStatusReport },
  { value: 'assets-sold-summary-report', label: 'Buyer/Seller Assets Sold Summary', Component: AssetsSoldSummary },
  { value: 'seller-confirmation-report', label: 'Seller Confirmation Report', Component: SellerConfirmationReport },
  { value: 'website-buyers-report', label: 'Website Buyers Report', Component: WebsiteBuyersReport },
  { value: 'fees-not-approved-report', label: 'Fees Not Approved Report', Component: FeesNotApprovedReport },
  { value: 'journal-entry-report', label: 'Journal Entry Report', Component: JournalEntryReport },
  { value: 'reversed-entry-report', label: 'Reversed Entry Report', Component: ReversedEntryReport },
  { value: 'titles-to-work-report', label: 'Titles To Work Report', Component: TitlesToWorkReport },
];
